import { useEffect, useState } from "react";
import { useFormik } from "formik";
import axiosInstance from "../../../axiosInterceptor";
import { pageSchema } from "../../../Schema/Schema";
import { toast } from "react-toastify";

const AddPage = ({ editData, fetchPaginationData }) => {
 const editingId = editData?.id;
 const [loading, setLoading] = useState(false);
 const initialValues = {
  page: "",
  action: "",
 };

 const {
  errors,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  resetForm,
  touched,
 } = useFormik({
  initialValues,
  validationSchema: pageSchema,
  onSubmit: async (values, { resetForm }) => {
   setLoading(true);
   try {
    const payload = {
     pageName: values.page,
     action: values.action
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean),
    };

    const response = editingId
     ? await axiosInstance.put(`/page/${editingId}`, payload)
     : await axiosInstance.post("/page", payload);

    if (response.status === 200) {
     toast.success(response?.data?.message);
     resetForm();
     fetchPaginationData && fetchPaginationData();
    }
   } catch (err) {
    toast.error(err?.response?.data?.message);
   } finally {
    setLoading(false);
   }
  },
 });

 useEffect(() => {
  if (editingId && editData) {
   setFieldValue("page", editData?.pageName || "");

   setFieldValue(
    "action",
    editData?.action?.length ? editData.action.join(", ") : ""
   );
  }
 }, [editingId, editData, setFieldValue]);
 return (
  <div className="row grid-margin stretch-card">
   <div className="col-md-12">
    <div className="card">
     <div className="card-body">
      <form onSubmit={handleSubmit}>
       <div className="row g-3">
        <div className="col-lg-6 col-md-12">
         <label className="col-form-label" htmlFor="page">
          Page
         </label>
         <input
          type="text"
          name="page"
          id="page"
          className="form-control form-control-sm border border-dark"
          placeholder="Enter Page name"
          value={values.page}
          onChange={handleChange}
          onBlur={handleBlur}
         />
         {touched.page && errors.page && (
          <div className="text-danger">{errors.page}</div>
         )}
        </div>

        <div className="col-lg-6 col-md-12">
         <label className="col-form-label" htmlFor="action">
          Action
         </label>
         <input
          type="text"
          name="action"
          id="action"
          placeholder="Add,Update,Delete,View,Status,Bulk Delete"
          className="form-control form-control-sm border border-dark"
          value={values.action}
          onChange={handleChange}
          onBlur={handleBlur}
         />
         {touched.action && errors.action && (
          <div className="text-danger">{errors.action}</div>
         )}
        </div>

        <div
         className="col-12 mt-4 d-flex justify-content-center "
         style={{ gap: "15px" }}
        >
         <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Loading..." : editingId ? "Update" : "Add"}
         </button>

         <button type="button" className="btn btn-danger"  onClick={() => resetForm()}>
          Cancel
         </button>
        </div>
       </div>
      </form>
     </div>
    </div>
   </div>
  </div>
 );
};

export default AddPage;
